import Transactions from "@/plugins/protokol/api/transactions"

export default class Checkout {
    constructor() {
        this.transactions = new Transactions()
    }

    async getCheckoutLink(opts) {
        return await this.transactions.checkoutLink(opts)
    }

    async startTrial(data) {
        return await this.transactions.startTrial(data)
    }
}